import React, {useMemo, useEffect, useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import clsx from 'clsx';
import { useForm, Controller } from "react-hook-form";

// @material-ui/core components
import DateFnsUtils from '@date-io/date-fns';
import frLocale from "date-fns/locale/fr";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';
import Autocomplete from '@material-ui/lab/Autocomplete';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

// import { black } from '@material-ui/core/colors';

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

import Tooltip from '@material-ui/core/Tooltip';
import MUIButton from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { InputLabel, Select, FilledInput, MenuItem, FormControl, InputAdornment, FormHelperText, TextField, FormLabel, FormControlLabel, Radio, RadioGroup, Switch } from "@material-ui/core";
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import Modal from '@material-ui/core/Modal';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

// @material-ui/icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

//aggrid
import {AgGridReact} from "@ag-grid-community/react";

import Dialog from '@material-ui/core/Dialog';
import SweetAlert from "react-bootstrap-sweetalert";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import Client from "components/soubrier/Clients/Client.js";
import AdditionalInfo from "components/soubrier/Commons/AdditionalInfo.js";
import Prolongations from "components/soubrier/Prolongations/Prolongations.js";
import ArticlesSelectV2 from "components/soubrier/Articles/ArticlesSelectV2.js";

import DevisService from "services/devis.service";
import ClientsService from "services/clients.service";

import NumericCellEditor from "components/soubrier/AgGrid/NumericCellEditor.js";
import AvailabilitiesCellEditor from "components/soubrier/AgGrid/AvailabilitiesCellEditor.js";
import BooleanCellEditor from "components/soubrier/AgGrid/BooleanCellEditor.js";
import ListBox from "components/soubrier/Commons/ListBox.js";

import PDFGenerator from "components/soubrier/Pdf/PDFGenerator.js";
import HtmlEntities from "components/soubrier/Commons/HtmlEntities.js";

import defaultImage from "assets/img/default-image.jpeg";

import styles from "assets/jss/soubrier/components/devisStyle.js";

const useStyles = makeStyles(styles);

const addButtonOptions = [{id: 0, label: 'Ajouter un article'}, {id:1, label: 'Ajouter une ligne'}];

export default function Devis(props) {

  const { onSubmit, onCancel, onDelete, devis_id, readOnly } = props;
  const { register, unregister,reset, handleSubmit, errors, control, setValue, getValues, watch, formState, setError } = useForm();
  const [articleSelectDialogOpen, setArticleSelectDialogOpen] = useState(false);
  const [devis, setDevis] = useState(null);
  const [selectedArticlesId, setSelectedArticlesId] = useState([]);
  const [rowData, setRowData] = useState([]);
  // const [selected, setSelected] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [gridReady, setGridReady] = useState(false);
  const [params, setParams] = useState(null);
  const [refresh, setRefresh] = useState(Math.random());
  const [contactRefresh, setContactsRefresh] = useState(Math.random());
  
  const [loading, setLoading] = useState(!!devis_id);
  const [alert, setAlert] = useState(null);
// Picture Modal
  const [displayPicture, setDisplayPicture] = useState(null);
  const PUBLIC_URL = window.__RUNTIME_CONFIG__.REACT_APP_PUBLIC_URL;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedAdd, setSelectedAdd] = useState(0);
  const [contacts, setContacts] = useState([]);
  const [contactDialog, setContactDialog] = useState(false);
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const [additionalInfoDialog, setAdditionalInfoDialog] = useState(false);
  const [additionalInfoDialogOpen, setAdditionalInfoDialogOpen] = useState(false);
  const [devisChanged, setDevisChanged] = useState(false);
  const [dateDebutLocation, setDateDebutLocation] = useState(null);
  const [dateFinLocation, setDateFinLocation] = useState(null);
  const [dateFacturation, setDateFacturation] = useState(null);
  const [total, setTotal] = useState(null);
  // const [totalHt, setTotalHt] = useState(null);
  const [sousTotalHt, setSousTotalHt] = useState(null);
  const [tva, setTva] = useState(null);
  const [remise, setRemise] = useState(0);
  const [numeroFacture, setNumeroFacture] = useState(null);
  const [statut, setStatut] = useState(null);
  const [totalValeur, setTotalValeur] = useState(0);
  const [displayValeur, setDisplayValeur] = useState(null);
  const [affectation, setAffectation] = useState(null);
  const [affectationManuallyChanged, setAffectationManuallyChanged] = useState(null);
  const [prolongations, setProlongations] = useState(null);
  const [availabilities, setAvailabilities] = useState([]);

  const classes = useStyles();

  const CONTACT_DECORATEUR_TYPE = "decorateur";
  const CONTACT_CLIENT_TYPE = "client";

  const devisOptions = {
    date_fin_location: { 
      required: {value: true, message: "Please Add date"},
      validate: {
        // validateDate: (e) => {console.log(e, dateDebutLocation, getValues("date_fin_location")); return false},
        validateDate: (e) => {return true},
      }
    }
    // numero_facture: {
    //   required: {value: true, message: "Renseignez un numéro de facture"},
    // }
    // 
    // ref: { required: "La référence est obligatoire", validate: {refIsUnique: async (e) => await refIsUnique(e)}},
    // categorie: { required: "Choisissez une catégorie" },
    // type: { required: "Choisissez une sous-catégorie" },
    // epoque: { required: "Choisissez une époque" },
    // libelle_fr: { required: "Renseignez un titre en français" },
    // description_fr: { required: "Renseignez une description en français" },
  };


  const handleRegistration = async (alert, data) => {
    data.Prolongations = prolongations;
    data.client_id = data.client?.client_id ? data.client.client_id : null;
    data.decorateur_id = data.decorateur?.client_id ? data.decorateur.client_id : null;

    let newRowData = [];
    gridApi.forEachNode(row => {
      row.data.devis_article.ordering = row.rowIndex+1;
      newRowData = [...newRowData, row.data];
    })


    data.Articles = newRowData.reduce((acc, item) => {
      if (item.article_id)
        acc.push(item.devis_article);
      return acc
    }, []);
    
    data.Lignes = newRowData.reduce((acc, item) => {
      if (!item.article_id)
        acc.push(item.devis_article);
      return acc
    }, []);

    setDevisChanged(false);
    onSubmit(data, alert);
  }

  const handleError = (errors) => {
    console.log(errors)
    // formErrorMessage(errors);
  };

  async function makePdf(elem) {
    const document = new PDFGenerator(elem)
    await document.init();
    document.generate();
  }

  // Contact METHODES
  const manageContactDialog = (id, readOnly=false, contactType) => {
    // console.log(id, readOnly, contactType);
    setContactDialog(
        <span>
        <DialogContent>
          <Client readOnly={readOnly} client_id={id} onSubmit={onSubmitContact.bind(null, contactType)} onCancel={handleCloseContactDialog} onDelete={onDeleteContact.bind(null, contactType)}/> 
        </DialogContent>
        </span>
    );
    setContactDialogOpen(true);
  };

  const handleCloseContactDialog = useCallback(() => setContactDialogOpen(false), []);

  const manageAdditionalInfoDialog = () => {
    setAdditionalInfoDialog(
        <DialogContent>
          <AdditionalInfo data={JSON.parse(devis.front_additional_data)}/> 
        </DialogContent>
    );
    setAdditionalInfoDialogOpen(true);
  };
  const handleCloseAdditionalInfoDialog = useCallback(() => setAdditionalInfoDialogOpen(false), []);

  const successContactAlert = (remove) => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title={remove ? "Contact supprimé!": "Contact sauvegardé!"}
        onConfirm={() => {hideAlert(); handleCloseContactDialog();}}
        onCancel={() => hideAlert()}
        cancelBtnCssClass={classes.button}
        confirmBtnCssClass={classes.button + " " + classes.success}
        confirmBtnText="Ok"
        cancelBtnText="Retour"
        showCancel
      >
      </SweetAlert>
    );
  };

  
  const onSubmitContact = (contactType, client, alert) => {
    const callfunc = client.client_id ? ClientsService.edit : ClientsService.add;
    callfunc({...client})
    .then(function (response) {
      setContactsRefresh(Math.random());
      if (alert) successContactAlert(false);
      if (contactType === CONTACT_DECORATEUR_TYPE) {
        setValue("decorateur", response.data);
        setValue("decorateur_id", response.data.client_id);
      } else {
        setValue("client", response.data);
        setValue("client_id", response.data.client_id);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  const onDeleteContact = (contactType, client_ids, alert) => {
    ClientsService.remove({client_ids: client_ids})
    .then(function (response) {
      if (contactType === CONTACT_DECORATEUR_TYPE) {
        setValue("decorateur", null);
        setValue("decorateur_id", null);
      } else {
        setValue("client", null);
        setValue("client_id", null);
      }
      setContactsRefresh(Math.random());
      successContactAlert(true);
      handleCloseContactDialog();
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  const handleClick = () => {
    if (addButtonOptions[selectedAdd]["id"] == 0)
      setArticleSelectDialogOpen(true);
    else 
      addNewLigne();
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedAdd(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  
  const dialogStyles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

  const DialogTitle = withStyles(dialogStyles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const warningPriceChangeConfirmMessage = (data) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Modifier le prix de location définitivement ?"
        onConfirm={() =>  {
          data.devis_article.update_article_price = true;
          updateArticle(data);
          hideAlert();
        }}
        onCancel={() => {
          data.devis_article.update_article_price = false;
          updateArticle(data);
          hideAlert();
        }}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      >
        Voulez-vous modifier le prix de location de cet article définitivement ?
        Il sera prit en compte dans ce devis et les prochains.
      </SweetAlert>
    );
  };

  const warningValeurChangeConfirmMessage = (data) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Modifier la valeur définitivement ?"
        onConfirm={() =>  {
          data.devis_article.update_article_valeur = true;
          updateArticle(data);
          hideAlert();
        }}
        onCancel={() => {
          data.devis_article.update_article_valeur = false;
          updateArticle(data);
          hideAlert();
        }}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      >
        Voulez-vous modifier la valeur de cet article définitivement ?
        Il sera prit en compte dans ce devis et les prochains.
      </SweetAlert>
    );
  };

  const warningDescriptionChangeConfirmMessage = (data) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Modifier la description définitivement ?"
        onConfirm={() =>  {
          data.devis_article.update_article_description = true;
          updateArticle(data);
          hideAlert();
        }}
        onCancel={() => {
          data.devis_article.update_article_description = false;
          updateArticle(data);
          hideAlert();
        }}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      >
        Voulez-vous modifier la description de cet article définitivement ?
        Il sera prit en compte dans ce document et les prochains.
      </SweetAlert>
    );
  };

  const hideAlert = () => setAlert(null);

  const handleCloseArticleSelectDialog = () => {
    setArticleSelectDialogOpen(false);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const onUpdateSelected = (article) => {
    if(article.childs.length)
      addEnsemble(article.childs);
    else {
      if (rowData.find(a => a.article_id === article.article_id))
        removeArticle(article)
      else
        addArticle(article);
    }  
  }

  const cleanText = (text) => {
    text = text.replace(/\\/g, '');
    text = text.replace(/(<br ?\/?>)*/g,"");
    text = HtmlEntities.decode(text);
    return text;
  }

  const addEnsemble = (articles) => {
    articles = articles.filter(article => !rowData.find(a => a.article_id === article.article_id));
    const articles_id = articles.map(article => article.article_id);

    setRowData(existingItems => {
      
      return existingItems.concat([
        ...articles.map(article => {
          const availabilitiesFounds = availabilities.filter((element) => element.article_id === article.article_id);
          if (availabilitiesFounds) article.availabilities = availabilitiesFounds

          return {
            ...article,
            devis_article: {
              article_id: article.article_id,
              description: article.description_tech ? cleanText(article.description_tech) : cleanText(article.description_fr),
              devis_id: devis?.devis_id ? devis.devis_id : null,
              devise: devis?.devise ? devis.devise : '€',
              ordering: 99,
              prix_location: article.prix_location ? article.prix_location : 0,
              quantite: article.nb_elem ? article.nb_elem : 1,
              valeur: article.valeur ? article.valeur : 0,
              date_crea: new Date(),
              date_modif: new Date()
            }
          }
        })
      ])
    });
    setSelectedArticlesId([...selectedArticlesId, ...articles_id]);
    setDevisChanged(true);
  }

  const addArticle = (article) => {

    const availabilitiesFounds = availabilities.filter((element) => element.article_id === article.article_id);
    if (availabilitiesFounds) article.availabilities = availabilitiesFounds

    const devis_article = {
      article_id: article.article_id,
      description: article.description_tech ? cleanText(article.description_tech) : cleanText(article.description_fr),
      devis_id: devis?.devis_id ? devis.devis_id : null,
      devise: devis?.devise ? devis.devise : '€',
      ordering: 99,
      prix_location: article.prix_location ? article.prix_location : 0,
      quantite: article.nb_elem ? article.nb_elem : 1,
      valeur: article.valeur ? article.valeur : 0,
      date_crea: new Date(),
      date_modif: new Date(),
    };

    setRowData([...rowData, {...article, devis_article: devis_article}]);

    setSelectedArticlesId([...selectedArticlesId, article.article_id]);
    setDevisChanged(true);
  }

  const updateArticle = (article) => {
    setRowData(existingItems => {
      return existingItems.map(item => {
        return item.article_id === article.article_id ? { ...item, devis_article: {...item.devis_article, ...article.devis_article} } : item
      })
    });
    setDevisChanged(true);
  }
  
  const removeArticle = (article) => {
    setRowData(existingItems => {
      const itemIndex = existingItems.findIndex(item => item.article_id === article.article_id);
      return [
        ...existingItems.slice(0, itemIndex),
        ...existingItems.slice(itemIndex + 1),
      ]
    });

    setSelectedArticlesId(existingItems => {
      const itemIndex = existingItems.indexOf(article.article_id);
      return [
        ...existingItems.slice(0, itemIndex),
        ...existingItems.slice(itemIndex + 1),
      ]  
    });
    
    setDevisChanged(true);
  }

  const addNewLigne = () => {
    const devis_ligne = {
      tmp_id: Date.now(), 
      description: '',
      devis_id: devis?.devis_id ? devis.devis_id : null,
      devise: devis?.devise ? devis.devise : '€',
      ordering: 99,
      prix_location: 0,
      quantite: 1,
      valeur: 0,
      date_crea: new Date(),
      date_modif: new Date()
    };
    setRowData([...rowData, {devis_article: devis_ligne}]);
    setDevisChanged(true);
  }

  const updateLigne = (ligne) => {
    setRowData(existingItems => {
      return existingItems.map(item => {
        const condition = ((item.devis_article.devis_ligne_id !== undefined && item.devis_article.devis_ligne_id === ligne.devis_article.devis_ligne_id) 
          || (item.devis_article.tmp_id !== undefined && item.devis_article.tmp_id === ligne.devis_article.tmp_id));
        return condition ? { ...item, devis_article: {...item.devis_article, ...ligne.devis_article} } : item
      })
    })
    setDevisChanged(true);
  }

  const removeLigne = (ligne) => {
    setRowData(existingItems => {
      const itemIndex = existingItems.findIndex(item => {
        const condition = ((item.devis_article.devis_ligne_id !== undefined && item.devis_article.devis_ligne_id === ligne.devis_article.devis_ligne_id) 
        || (item.devis_article.tmp_id !== undefined && item.devis_article.tmp_id === ligne.devis_article.tmp_id));
        return condition
      });
      return [
        ...existingItems.slice(0, itemIndex),
        ...existingItems.slice(itemIndex + 1),
      ]
    })
    setDevisChanged(true);
  }

  const onChangeOrders = (params) => {
    let newRowData = [];
    params.api.forEachNode(row => {
      row.data.devis_article.ordering = row.rowIndex+1;
      newRowData = [...newRowData, row.data];
    })
    setRowData(newRowData);
    setDevisChanged(true);
  }

  // Init value, only first load
  useEffect(() => {
    setValue("client_id", devis?.client_id ? devis.client_id : null, { shouldValidate: true });
    setValue("decorateur_id", devis?.decorateur_id ? devis.decorateur_id : null, { shouldValidate: true });
    if (!devis || !Object.keys(devis).length || !loading) return
    // console.log("SETTING VALUES", devis)
    setValue("devis_id", devis.devis_id, { shouldValidate: true });
    setValue("date_debut_location", devis.date_debut_location ? new Date(devis.date_debut_location).toISOString().slice(0, 10) : null, { shouldValidate: true });
    setValue("date_fin_location", devis.date_fin_location ? new Date(devis.date_fin_location).toISOString().slice(0, 10) : null, { shouldValidate: true });
    if (!devis.date_facturation) {
      devis.date_facturation = devis.date_modif;
      setDevisChanged(true);
    }
    setValue("date_facturation", devis.date_facturation ? new Date(devis.date_facturation).toISOString().slice(0, 10) : null, { shouldValidate: true });
    setValue("client", devis.client ? devis.client : null, { shouldValidate: true });
    setValue("decorateur", devis.Decorateur ? devis.Decorateur : null, { shouldValidate: true });
    setValue("film", devis.film ? devis.film : "", { shouldValidate: true });
    setValue("libelle", devis.libelle ? devis.libelle : "", { shouldValidate: true });
    setValue("decor", devis.decor ? devis.decor : "", { shouldValidate: true });
    setValue("total", devis.total ? devis.total : 0, { shouldValidate: true });
    setValue("total_ht", devis.total_ht ? devis.total_ht : 0, { shouldValidate: true });
    setValue("sous_total_ht", devis.sous_total_ht ? devis.sous_total_ht : 0, { shouldValidate: true });
    setValue("total_ttc", devis.total_ttc ? devis.total_ttc : 0, { shouldValidate: true });
    setValue("total_tva", devis.total_tva ? devis.total_tva : 0, { shouldValidate: true });
    setValue("tva", devis.tva ? devis.tva : 20, { shouldValidate: true });
    setValue("affectation", devis.affectation ? devis.affectation : "france", { shouldValidate: true });
    setValue("caution", devis.caution ? devis.caution : 0, { shouldValidate: true });
    setValue("reglement", devis.reglement ? devis.reglement : 0, { shouldValidate: true });
    setValue("remise_libelle", devis.remise_libelle ? devis.remise_libelle : "", { shouldValidate: true });
    setValue("display_valeur", devis.display_valeur ? devis.display_valeur : false, { shouldValidate: true });
    setValue("numero_facture", devis.Facture?.numero_facture ? devis.Facture.numero_facture : '', { shouldValidate: true });
    setValue("numero_bon_sortie", devis.numero_bon_sortie ? devis.numero_bon_sortie : "", { shouldValidate: true });
    setValue("numero_devis", devis.numero_devis ? devis.numero_devis : "", { shouldValidate: true });
    setValue("total_valeur", devis.total_valeur ? devis.total_valeur : 0, { shouldValidate: true });

    const remise = devis.remise ? (devis.remise < 0 ?  devis.remise * -1 : devis.remise) : 0;
    setValue("remise", remise, { shouldValidate: true });
    
    setStatut(devis.statut ? devis.statut : 2);
    setRemise(remise);
    setNumeroFacture(devis.Facture?.numero_facture ? devis.Facture.numero_facture : '');
    setDateDebutLocation(devis.date_debut_location ? new Date(devis.date_debut_location) : null);
    setDateFinLocation(devis.date_fin_location ? new Date(devis.date_fin_location) : null);
    setProlongations(devis.Prolongations);
    setTotal(devis.total ? devis.total : 0);
    // setTotalHt(devis.total_ht ? devis.total_ht : 0);
    setSousTotalHt(devis.sous_total_ht ? devis.sous_total_ht : 0);
    setTva(devis.tva ? devis.tva : 0);
    setTotalValeur(devis.total_valeur ? devis.total_valeur : 0);
    setAffectation(devis.affectation ? devis.affectation : "france")
    setDisplayValeur(devis.display_valeur ? devis.display_valeur : false)
    setLoading(false);
  }, [devis]);


  useEffect(() => {
    if (!devis_id) return
    setLoading(true);
    setParams({"id": devis_id});
  }, [devis_id]);

  useEffect(() => {
    if (!devis || loading) return
    if (devis.statut === 1) {
      devis.statut = 2;
      setDevisChanged(true);
    }
    setValue("statut", devis.statut ? devis.statut : 2, { shouldValidate: true });
    setStatut(devis.statut ? devis.statut : 2);
  }, [devis, loading]);

  useEffect(() => {
    if (loading || !affectationManuallyChanged) return
    if (affectation === "france"){
      setDisplayValeur(false);
      setValue("display_valeur", false);
    } else {
      setDisplayValeur(true);
      setValue("display_valeur", true);
    }
  }, [affectationManuallyChanged]);

  useEffect(() => {
    if (!tva) return
    const total_tva = Number.roundToTwo(parseFloat(getValues("total_ht") * tva  / 100));
    const total_ttc = Number.roundToTwo(parseFloat(total_tva + getValues("total_ht")));
    
    setValue("total_tva", total_tva);
    setValue("total_ttc", total_ttc);
  }, [tva]);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
        // console.log("DEVIS WATCH", value, name, type)
        if (type === "change")
          setDevisChanged(true);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  // useEffect(() => {
  //   if (devisChanged)
  //     console.log("DEVIS CHANGED FOR GOOD =>>> SAVE")
  // }, [devisChanged]);


  useEffect(() => {
    if (!prolongations || totalValeur === null) return
    const objDiff = devis && (JSON.stringify(devis.Prolongations) !== JSON.stringify(prolongations)
      || devis.total_valeur != totalValeur);
    if (objDiff)
      setDevisChanged(true)

    const sous_total_ht = Number.roundToTwo(prolongations.reduce((acc, prolong) => {
      acc += parseFloat(prolong.total);
      return acc;
    }, 0));
    
    const total_ht = Number.roundToTwo(sous_total_ht - remise);
    const total_tva = Number.roundToTwo((total_ht * getValues("tva")) / 100);
    const total_ttc = Number.roundToTwo(total_tva + total_ht);

    setValue("total_ht", total_ht);
    // setTotalHt(total_ht)
    setValue("sous_total_ht", sous_total_ht);
    setSousTotalHt(sous_total_ht)
    setValue("total_tva", total_tva);
    setValue("total_ttc", total_ttc);

  }, [prolongations, remise, totalValeur]);



  const calc_total = (rows, field) => {
    const itemsTotal = rows.reduce((acc, ligne) => {
      // console.log(ligne);
      if (ligne.devis_article.hasOwnProperty("indisponible") && ligne.devis_article.indisponible)
        return acc;
      if (field == "prix_location")
        acc += ligne.devis_article[field] * ligne.devis_article.quantite;
      else
        acc += ligne.devis_article[field];
      return acc;
    }, 0);
    return Number.roundToTwo(itemsTotal);
  }

  // MAJ du prix total et de la valeur total quand rowData change
  useEffect(() => {
    if (!rowData) return
    const total = calc_total(rowData, 'prix_location');
    const total_valeur = calc_total(rowData, 'valeur');
    setValue("total", total);
    setValue("total_valeur", total_valeur);
    setTotal(total);
    setTotalValeur(total_valeur);
    setValue("nb_elements", rowData.reduce((acc, elem) => acc + elem.devis_article.quantite, 0));
    setValue("nb_lignes", rowData.length);
    // if (rowData.length !== devis. )
    // setDevisChanged(true);
    if (!total)
      setProlongations([])
  }, [rowData]);
  
  useEffect(() => {
    if (readOnly) return
    // console.log("CLIENTS DB REQUEST")
    ClientsService.getAll({
      limit: 0,
      attributes: ['client_id', 'nom', 'prenom', 'societe']
    }).then((resp) => {
      setContacts(resp.data);
    });
  }, [contactRefresh]);

  useEffect(() => {
    if (!gridApi || !gridColumnApi) return
    
    if (params?.id) {
      gridApi.showLoadingOverlay();
      let source = DevisService.initSource();

      DevisService.getOne(params, source)
        .then((resp) => {
          const dataRows = formatRowData(resp.data);
          if (dataRows.length)
            gridApi.hideOverlay();
          else
            gridApi.showNoRowsOverlay();
          setDevis(resp.data);
          setSelectedArticlesId(resp.data.Articles.map(d => d.article_id))
          setRowData(dataRows);
        });
      return function () {
        source.cancel("Cancelling API Call in cleanup");
      };
    }
  }, [gridApi, gridColumnApi, refresh, params]);

  useEffect(() => {
    if (!dateDebutLocation || !dateFinLocation) return
      gridApi.gridOptionsWrapper.gridOptions.context = {dateDebutLocation: dateDebutLocation, dateFinLocation: dateFinLocation};
      DevisService.get('availabilities', {
        date_debut_location: new Date(dateDebutLocation),
        date_fin_location: new Date(dateFinLocation),
        devis_id: devis?.devis_id ? devis.devis_id : null
      }).then((resp) => {
        setAvailabilities(resp.data);
        const availabilities = resp.data;
        setRowData(existingItems => {
          return existingItems.map(item => {
            const founds = availabilities.filter((element) => element.article_id === item.article_id);
            // console.log(founds);
            return founds.length ? { ...item, availabilities: founds } : { ...item, availabilities: [] }
          })
        });
        var params = {
          force: false,
          suppressFlash: true,
          columns: ["indisponible"]
        }
        gridApi.refreshCells(params);
      });
  }, [dateDebutLocation, dateFinLocation, devis]);


  useEffect(() => {
    if (!gridApi) return
    window.addEventListener('resize', resizeColumn);
    return () => {
      window.removeEventListener('resize', resizeColumn);
    };
  }, [gridApi]);

  const resizeColumn = () => {
    setTimeout(function () {
      gridApi.sizeColumnsToFit();
    });
  }

  const formatRowData = (data) => {
    return [].concat(data.Articles.map(article => {
      return {...article, devis_article: {...article.devis_article, devise: data.devise}}
    }).concat(data.Lignes.map(ligne => {
      return {devis_article: {...ligne, devise: data.devise}}
    }))).sort(function (a, b) {
      return a.devis_article.ordering - b.devis_article.ordering;
    });
  }

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    setGridReady(true);
    params.api.sizeColumnsToFit();
  };

  const onCellValueChanged = (params) => {
    // If article and location price changed,
    // Ask if we are doing a global update
    const devisElem = params.data;
    if (params.data.article_id) {
      if (params.column.colId === 'prix_location')
        warningPriceChangeConfirmMessage(devisElem);
      else if (params.column.colId === 'valeur')
        warningValeurChangeConfirmMessage(devisElem);
      else if (params.column.colId === 'description')
        warningDescriptionChangeConfirmMessage(devisElem);
      else
        updateArticle(devisElem);
    }else
      updateLigne(devisElem);
    // params.api.redrawRows();
  }

  // const onRowDragEnd = (params) => {
  //   if (!onChangeOrders) return
  //   let orders = {articles: [], lignes: []};

  //   params.api.forEachNode(row => {
  //     if (row.data.devis_article.devis_article_id)
  //       orders['articles'].push({devis_article_id: row.data.devis_article.devis_article_id, ordering: row.rowIndex+1 })
  //     if (row.data.devis_article.devis_ligne_id)
  //       orders['lignes'].push({devis_ligne_id: row.data.devis_article.devis_ligne_id, ordering: row.rowIndex+1 })
  //     row.data.devis_article.ordering = row.rowIndex+1;
  //   })
  //   onChangeOrders(orders)
  // }
  // const onRowSelected = (params) => setSelected(params.api.getSelectedRows().map(o => o.devis_id));
  // const onCellClicked = (params) => params.column.colId !== 'tools' ? params.node.setSelected(!params.node.selected) : null;
  
  const onCellClicked = (params) => {
    if (params.colDef.field === "photo" && params.value) {
      setDisplayPicture(
        <Modal 
          className={classes.modal}
          open={true}
          onClose={hidePictureModal}
        >
        <div className={classes.paper}>
          <img style={{width: "100%"}} src={PUBLIC_URL+"/photos/articles/medium/"+params.value} />
        </div>
        </Modal>
      );
    }
  };
  const hidePictureModal = () => setDisplayPicture(null);

  const actionsDrawer = (params) => [
    { 
      color: "danger",
      icon: Close,
      onclick: (e) => params.data.devis_article.article_id ? removeArticle(params.data) : removeLigne(params.data)
    },
    ...(params.data?.article_id ? [{ color: "success",
      icon: Edit,
      tooltip: "Editer l'article",
      onclick: (event) => {
        window.open(`/admin/catalogue/articles/edit/${params.data.article_id}`, "_blank");
        // history.push({
        //   pathname: `/admin/catalogue/articles/edit/${params.data.devis_article.article_id}`,
        //   state: {
        //     filters: filters,
        //     sortModel: sortModel
        //   }
        // })
      }
    }]: []),
  ].map((prop, key) => {
    return (
      <Button
        round
        color={prop.color}
        onClick={prop.onclick}
        className={classes.actionButton + " " + classes.actionButtonRound}
        key={key}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });

  const pictureDrawer = params => {
    const element = document.createElement('span');
    const imageElement = document.createElement('img');

    if (!params.data.devis_article.article_id && (!params.data.devis_article.quantite && !params.data.devis_article.prix_location))
      return element

    if (params.value)
      imageElement.src = `${PUBLIC_URL}/photos/articles/thumb/${params.value}`;
    else 
      imageElement.src = defaultImage;
    imageElement.style = "width:70px; height:70px;"
    
    element.appendChild(imageElement);
    return element;
  };

  
  const quantityEditorSelector = (params) => {
    if (params.data.article_id) {
      const nb_elem = params.data.nb_elem ? params.data.nb_elem : 1;
      return {
        component: 'agSelectCellEditor',
        params: {
          values: [...Array(nb_elem+1).keys()] 
        },
      };
    }
    return {
      component: 'numericCellEditor',
    };
  }

  const columnDefs = useMemo( ()=> [
      {
        colId: 'tools',
        headerName: '',
        cellRenderer: 'actionsDrawer',
        width: 120,
        resizable: false,
        suppressSizeToFit: true
      },{ 
        field: 'photo',
        headerName: '',
        cellRenderer: 'pictureDrawer',
        width: 70,
        resizable: false,
        suppressSizeToFit: true,
        cellStyle: params => {
          return {padding: '0', border: "none", cursor: 'pointer'};
        },
      },{
        field: 'ref',
        headerName: 'Ref',
        width: 120,
        suppressSizeToFit: true,
        valueGetter: params => {
          return params.data.ref?.toUpperCase()
        },
        // valueGetter: params => params.data.Articles.length+params.data.devis_lignes.length,
      },{
        colId: 'description',
        field: 'devis_article.description',
        headerName: 'Description',
        cellEditor: 'agLargeTextCellEditor',
        cellEditorPopup: true,
        editable: true,
        width: 130,
        // valueGetter: params => params.data.Articles.length+params.data.devis_lignes.length,
      },{
        colId: 'indisponible',
        field: 'devis_article.indisponible',
        headerName: 'Indisponibilité',
        suppressSizeToFit: true,
        cellRendererSelector: params => {
          if (params.data.article_id)
            return { component: 'availabilitiesCellEditor' }
          return null
        },
        valueGetter: params => {
          return params.data.devis_article.indisponible
        },
        width: 140,
        minWidth: 140
      }
      // ,
      // ...statut === 1 ? [{
      //   field: 'dispo',
      //   headerName: 'Dispo',
      //   width: 120,
      //   suppressSizeToFit: true,
      //   valueGetter: params => {
      //     return params.data.availabilities?.length
      //   },
      // }] : []
      ,{
        colId: 'quantite',
        field: 'devis_article.quantite',
        headerName: 'Quantité',
        cellEditorSelector: quantityEditorSelector,
        cellEditorPopup: false,
        editable: true,
        valueGetter: params => {
          return !isNaN(parseInt(params.data.devis_article.quantite)) ? parseInt(params.data.devis_article.quantite) : 0
        },
        width: 90,
        minWidth: 90
      },{
        colId: 'valeur',
        field: 'devis_article.valeur',
        headerName: 'Valeur',
        cellEditor: 'numericCellEditor',
        cellEditorPopup: true,
        editable: true,
        width: 130,
        type: 'rightAligned',
        valueGetter: params => params.data.devis_article.valeur ? params.data.devis_article.valeur : 0,
        valueFormatter: params => params.value.toLocaleString("fr-FR", {style:"currency", currency:"EUR"}),
      },{
        colId: 'prix_location',
        field: 'devis_article.prix_location',
        headerName: 'Prix location unitaire',
        cellEditor: 'numericCellEditor',
        cellEditorPopup: true,
        editable: true,
        width: 130,
        type: 'rightAligned',
        valueGetter: params => params.data.devis_article.prix_location ? params.data.devis_article.prix_location : 0,
        valueFormatter: params => params.value.toLocaleString("fr-FR", {style:"currency", currency:"EUR"}),
      }
      ,{
        field: 'devis_article.date_modif',
        headerName: 'Date ajout',
        valueFormatter: params => {
          return params.value ? (new Date(params.value)).toLocaleString() : '';
        },
        width: 200,
      }
  ], []);

    // never changes, so we can use useMemo
  const defaultColDef = useMemo( ()=> ({
      resizable: true,
      sortable: false,
      cellStyle: params => {
        return {lineHeight: '70px', fontSize: "16px", border: "none"};
        }
  }), []);

  const getLabelClient = (option) => {
    let optionLabel = null;
    if (option.nom || option.prenom) {
      if (option.prenom) 
        optionLabel = option.prenom[0].toUpperCase() + option.prenom.substring(1).toLowerCase() + ' ';
      if (option.nom)
        optionLabel += option.nom.toUpperCase() + ' ';
    }
    if (option.societe) {
      if (optionLabel)
        optionLabel += '('+option.societe+')'
      else
      optionLabel = option.societe
    }
    return optionLabel
  }

  const localeText = useMemo(() => {
    return AG_GRID_LOCALE_FR;
  }, []);
  
  return (
    <div style={{height:'100%'}}>
      {alert}
      <Dialog maxWidth={"md"} fullWidth={true} open={contactDialogOpen} onClose={handleCloseContactDialog} aria-labelledby="form-dialog-title">
        {contactDialog}
      </Dialog>
      <Dialog id="addional-data-dialog" maxWidth={"xs"} open={additionalInfoDialogOpen} onClose={handleCloseAdditionalInfoDialog} aria-labelledby="addional-data-dialog-title">
        <DialogTitle id="addional-data-dialog-title" onClose={handleCloseAdditionalInfoDialog} >
          Données suplémentaires du devis
        </DialogTitle>
        {additionalInfoDialog}
      </Dialog>
      <Dialog fullScreen open={articleSelectDialogOpen} onClose={handleCloseArticleSelectDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="customized-dialog-title" onClose={handleCloseArticleSelectDialog}>
         Selection des articles
        </DialogTitle>
        <DialogContent>
          <ArticlesSelectV2 selected={selectedArticlesId} updateSelected={onUpdateSelected} onClose={handleCloseArticleSelectDialog} selectChilds /> 
        </DialogContent>
      </Dialog>
      <form onSubmit={handleSubmit(handleRegistration.bind(null, true), handleError)} className={classes.root}>
      <GridContainer style={{height:'100%'}}>
        <Backdrop className={classes.loader} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <GridItem xs={12} sm={12} style={{height:'100%'}}>
          <Card style={{height:'100%'}}>
            <CardHeader>
              <Button onClick={() => onCancel()} style={{width: "100px", marginRight:"10px"}}>Retour</Button>
              {
                getValues("devis_id") ? 
                    <Button onClick={() => onDelete(getValues("devis_id"))} color="danger" style={{width: "100px", marginRight:"10px"}} >Supprimer</Button>
                : null
              }
              <Button color="success" type="submit" disabled={!devisChanged} style={{width: "100px"}}>Enregister</Button>
            </CardHeader>
            <CardBody style={{ width: '100%', height: '100%' }}>
              <GridContainer style={{height:'100%'}}>
                <GridItem xs={12} sm={12} md={4} lg={12} xl={2} style={{height:'100%'}}>
                  <GridContainer style={{height:'100%'}} alignItems="flex-start" direction="row">
                    {devis && devis.front_additional_data &&
                    <GridItem style={{width: "210px"}}>
                      <div style={{marginTop: '16px'}}>
                        <Button color={"warning"} onClick={()=> manageAdditionalInfoDialog()} >Informations devis</Button>
                      </div>
                    </GridItem>
                    }
                    {devis && 
                    <GridItem style={{width: "210px"}}>
                      <div style={{marginTop: '16px', marginBottom: '8px'}}>
                        <Controller
                          name={"numero_devis"}
                          rules={devisOptions.numero_devis}
                          control={control}
                          defaultValue=""
                          render={({ 
                            field: { onChange, value },
                            fieldState: { invalid, isTouched, isDirty, error }
                          }) => (
                            <FormControl className={clsx(classes.margin, classes.textField)} variant="filled">
                              <InputLabel htmlFor="numero_devis" style={{marginLeft: '35px', marginTop:"-5px", color: "white"}}>Devis</InputLabel>
                                <FilledInput
                                  id="numero_devis"
                                  type="text"
                                  value={value}
                                  style={{width:"180px", backgroundColor: "#00acc1", color: "white", fontWeight: "bold"}}
                                  margin="dense"
                                  // disabled={readOnly}
                                  inputProps={{
                                    spellCheck: false
                                  }}
                                  autoComplete='off'
                                  required
                                  disableUnderline
                                  disabled
                                  onChange={onChange}
                                  {...error && {"error": true}}
                                  
                                  startAdornment={
                                    <InputAdornment position="start" style={{marginTop: "0px", marginLeft:  "5px"}}>
                                      <IconButton
                                        aria-label="Générer Devis pdf"
                                        size="small"
                                        edge="start"
                                        onClick={() => makePdf({devis_id: devis.devis_id, type: 1})}
                                      >
                                        {1==1 ? <PictureAsPdf style={{ color: "white" }} fontSize="small"/> : <PictureAsPdf />}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />       
                            </FormControl>
                          )}
                        />
                      </div>
                    </GridItem>
                    }
                    {devis && 
                    <GridItem style={{height:'100%'}}>
                      <div style={{marginTop: '16px', marginBottom: '8px'}}>
                        <Controller
                          name={"numero_bon_sortie"}
                          rules={devisOptions.numero_bon_sortie}
                          control={control}
                          defaultValue=""
                          render={({ 
                            field: { onChange, value },
                            fieldState: { invalid, isTouched, isDirty, error }
                          }) => (
                            <FormControl className={clsx(classes.margin, classes.textField)} variant="filled">
                              <InputLabel htmlFor="numero_bon_sortie" style={{marginLeft: '35px', marginTop:"-5px", color: "white"}}>Bon de sortie</InputLabel>
                                <FilledInput
                                  id="numero_bon_sortie"
                                  type="text"
                                  value={value}
                                  style={{width:"180px", backgroundColor: "#00acc1", color: "white", fontWeight: "bold"}}
                                  margin="dense"
                                  // disabled={readOnly}
                                  inputProps={{
                                    spellCheck: false
                                  }}
                                  autoComplete='off'
                                  required
                                  disableUnderline
                                  disabled
                                  onChange={onChange}
                                  {...error && {"error": true}}
                                  
                                  startAdornment={
                                    <InputAdornment position="start" style={{marginTop: "0px", marginLeft:  "5px"}}>
                                      <IconButton
                                        aria-label="Générer bon devis pdf"
                                        size="small"
                                        edge="start"
                                        onClick={() => makePdf({devis_id: devis.devis_id, type: 2})}
                                      >
                                        {1==1 ? <PictureAsPdf style={{ color: "white" }} fontSize="small"/> : <PictureAsPdf />}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />       
                            </FormControl>
                          )}
                        />
                      </div>
                      </GridItem>
                    }
                    {devis && [3,4].includes(statut) && 
                    <GridItem style={{height:'100%'}}>
                      <div style={{marginTop: '16px', marginBottom: '8px'}}>
                        <Controller
                          name={"numero_facture"}
                          rules={devisOptions.numero_facture}
                          control={control}
                          defaultValue=""
                          render={({ 
                            field: { onChange, value },
                            fieldState: { invalid, isTouched, isDirty, error }
                          }) => (
                            <FormControl className={clsx(classes.margin, classes.textField)} variant="filled">
                              <InputLabel htmlFor="numero_facture" style={{marginLeft: '35px', marginTop:"-5px", color: "white"}}>Facture</InputLabel>
                                <FilledInput
                                  id="numero_facture"
                                  type="text"
                                  value={value}
                                  style={{width:"180px", backgroundColor: "#00acc1", color: "white", fontWeight: "bold"}}
                                  margin="dense"
                                  disabled={readOnly || statut === 4 ? true : false}
                                  inputProps={{
                                    spellCheck: false
                                  }}
                                  autoComplete='off'
                                  // required
                                  disableUnderline
                                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                  onBlur={(e) => {
                                    const re = /^([0-9]{2}[a-zA-Z]{1})([0-9]{1,})/;
                                    const result = re.exec(e.target.value);
                                    if (result) {
                                      const formatedValue = result[1] + String(parseInt(result[2])).padStart(4, '0');
                                      if (e.target.value !== formatedValue) {
                                        e.target.value = formatedValue;
                                        setNumeroFacture(e.target.value);
                                        onChange(e);
                                      }
                                    }
                                  }}
                                  onChange={(e) => {
                                    setNumeroFacture(e.target.value);
                                    onChange(e);
                                  }}
                                  {...error && {"error": true}}
                                  
                                  startAdornment={
                                    <InputAdornment position="start" style={{marginTop: "0px", marginLeft:  "5px"}}>
                                      <IconButton
                                        aria-label="Générer facture pdf"
                                        size="small"
                                        edge="start"
                                        onClick={() => makePdf({devis_id: devis.devis_id, type: 3})}
                                      >
                                        {1==1 ? <PictureAsPdf style={{ color: "white" }} fontSize="small"/> : <PictureAsPdf />}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                  endAdornment={
                                    <InputAdornment position="end" style={{marginTop: "-20px", marginRight: "-10px"}}>
                                      <Tooltip
                                        title={
                                          <React.Fragment>
                                            <Typography variant="h5" color="inherit">Aide au numéro de facture</Typography>
                                            <Typography variant="body2" color="inherit">
                                              <u>{'Dernier numéro utilsé:'}</u>&nbsp;<b>{devis?.numero_facture_last}</b><br />
                                              <u>{'Prochain numéro potentiel:'}</u>&nbsp;<b>{devis?.numero_facture_next}</b><br />
                                            </Typography>
                                            
                                          </React.Fragment>
                                        }
                                      >
                                      <IconButton
                                        aria-label="Générer facture pdf"
                                        onClick={() => {
                                          if (!getValues("numero_facture") || getValues("numero_facture") === '') {
                                            let num = devis.numero_facture_next;
                                            if (devis.Facture?.numero_facture && devis.numero_facture_last === devis.Facture.numero_facture)
                                              num = devis.numero_facture_last
                                            setValue("numero_facture", num);
                                            setNumeroFacture(num);
                                            setDevisChanged(true);
                                          }
                                        }}
                                        size="small"
                                        edge="start"
                                      >
                                        <InfoOutlined style={{ color: "white", cursor: "pointer" }}/>
                                      </IconButton>
                                      </Tooltip>
                                    </InputAdornment>
                                  }
                                />       
                            </FormControl>
                          )}
                        />
                      </div>
                    </GridItem>
                    }
                    <GridItem xs={12} sm={12} md={12} lg={12} xl={12} style={{height:'100%'}}>
                      <GridContainer style={{height:'100%'}}>
                        <GridItem>
                          <Controller
                            name={"date_debut_location"}
                            
                            rules={devisOptions.date_debut_location}
                            control={control}
                            defaultValue={null}
                            render={({ 
                              field: { onChange, value },
                              fieldState: { invalid, isTouched, isDirty, error }
                            }) => (
                              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                                <KeyboardDatePicker
                                  id="date_debut_location"
                                  tata='date'
                                  disableToolbar
                                  required
                                  variant="inline"
                                  format="dd/MM/yyyy"
                                  margin="normal"
                                  style={{width:"180px"}}
                                  label="Début location"
                                  value={value}
                                  onChange={(value) => {
                                    if (value instanceof Date && !isNaN(value)) {
                                      // move the time away from midnight, opposite direction of utc offset
                                      const offset = -value.getTimezoneOffset();
                                      value.setHours(Math.trunc(offset / 60), offset % 60);
                                    }
                                    setDateDebutLocation(value);
                                    onChange(value);
                                  }}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                  inputProps={{
                                    'data-form-type': 'date'
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            )}
                          />
                          </GridItem>
                          <GridItem>
                          <Controller
                            name={"date_fin_location"}
                            // style={{display: "none"}}
                            rules={devisOptions.date_fin_location}
                            // rules={{ required: true }}
                            control={control}
                            defaultValue={null}
                            render={({ 
                              field: { onChange, value },
                              fieldState: { invalid, isTouched, isDirty, error }
                            }) => (
                              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                                
                                <KeyboardDatePicker
                                  id="date_fin_location"
                                  disableToolbar
                                  required
                                  variant="inline"
                                  // inputVariant="outlined"
                                  format="dd/MM/yyyy"
                                  style={{width:"180px"}}
                                  minDate={dateDebutLocation}
                                  minDateMessage={"Fin location inférieur au début"}
                                  margin="normal"
                                  label="Fin location"
                                  value={value}
                                  onChange={(value) => {
                                    if (value instanceof Date && !isNaN(value)) {
                                      // move the time away from midnight, opposite direction of utc offset
                                      const offset = -value.getTimezoneOffset();
                                      value.setHours(Math.trunc(offset / 60), offset % 60);
                                    }
                                    setDateFinLocation(value)
                                    onChange(value);
                                  }}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                  }}
                                  inputProps={{
                                    'data-form-type': 'date'
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            )}
                          />
                        </GridItem>
                        {devis && [3,4].includes(statut) && 
                        <GridItem>
                          <Controller
                            name={"date_facturation"}
                            // style={{display: "none"}}
                            rules={devisOptions.date_facturation}
                            // rules={{ required: true }}
                            control={control}
                            defaultValue={null}
                            render={({ 
                              field: { onChange, value },
                              fieldState: { invalid, isTouched, isDirty, error }
                            }) => (
                              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                                
                                <KeyboardDatePicker
                                  id="date_facturation"
                                  disableToolbar
                                  required
                                  variant="inline"
                                  // inputVariant="outlined"
                                  format="dd/MM/yyyy"
                                  style={{width:"180px"}}
                                  margin="normal"
                                  label="Date de facturation"
                                  value={value}
                                  onChange={(value) => {
                                    if (value instanceof Date && !isNaN(value)) {
                                      // move the time away from midnight, opposite direction of utc offset
                                      const offset = -value.getTimezoneOffset();
                                      value.setHours(Math.trunc(offset / 60), offset % 60);
                                    }
                                    onChange(value);
                                  }}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            )}
                          />
                        </GridItem>
                        }
                      </GridContainer>
                    </GridItem>
                    {/* <GridItem style={{height:'100%', width: '100%', marginTop: '8px'}} >
                      <GridContainer style={{height:'100%'}} alignItems="flex-start" direction="column">
                        
                      </GridContainer>
                    </GridItem> */}
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={4} lg={12} xl={2} style={{height:'100%'}}>
                  <GridContainer style={{height:'100%'}} alignItems="flex-start" direction="row">
                  {getValues("statut") &&
                  <GridItem style={{height:'100%', marginTop: '16px'}}>
                    <Controller
                        name={"statut"}
                        rules={devisOptions.statut}
                        control={control}
                        defaultValue="1"
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                          <FormControl variant="outlined" {...error && {error:true}} className={classes.selectFormControl}>
                          <InputLabel className={classes.selectLabel}>Statut du devis</InputLabel>
                          <Select

                            style={{ width: "180px"}}
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            name="statut"
                            onChange={(e) => {
                              setStatut(e.target.value);
                              onChange(e);
                            }}
                            value={value}
                            label="Statut du devis"
                            >
                            { numeroFacture === '' ?  
                            <MenuItem value={1} classes={{ root: classes.selectMenuItem }}>Non Lu</MenuItem>
                            : null }
                            { numeroFacture === '' ?  
                            <MenuItem value={2} classes={{ root: classes.selectMenuItem }}>Lu</MenuItem>
                            : null }
                            <MenuItem value={3} classes={{ root: classes.selectMenuItem }}>Validé</MenuItem>
                            { numeroFacture !== '' ?  
                            <MenuItem value={4} classes={{ root: classes.selectMenuItem }}>Annulé</MenuItem>
                            : null }
                          </Select>
                          <FormHelperText>{error && error.message}</FormHelperText>
                          </FormControl>
                        )}
                      />
                    </GridItem>
                    }
                    <GridItem>
                      <Controller
                        name={"caution"}
                        rules={devisOptions.caution}
                        control={control}
                        defaultValue={0}
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                          <TextField
                            id="caution"
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            style={{width:"180px"}}
                            disabled={readOnly}
                            label="Caution"
                            classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                            InputLabelProps={{className: classes.textFieldLabel}}
                            type="number"
                            InputProps={{
                              classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                              startAdornment: <InputAdornment position="start">€</InputAdornment>,
                              inputProps: { 
                                min: 0,
                                step: 0.01
                              }
                            }}
                            value={value}
                            onChange={onChange}
                            {...error && {"error": true}}
                            {...error && {helperText: error.message}}
                        />
                        )}
                      />
                    </GridItem>
                    <GridItem>
                      <Controller
                        name={"reglement"}
                        rules={devisOptions.reglement}
                        control={control}
                        defaultValue={0}
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                          <TextField
                            id="reglement"
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            style={{width:"180px"}}
                            disabled={readOnly}
                            label="Reglement"
                            classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                            InputLabelProps={{className: classes.textFieldLabel}}
                            type="number"
                            InputProps={{
                              classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                              startAdornment: <InputAdornment position="start">€</InputAdornment>,
                              inputProps: { 
                                min: 0,
                                step: 0.01
                              }
                            }}
                            value={value}
                            onChange={onChange}
                            {...error && {"error": true}}
                            {...error && {helperText: error.message}}
                        />
                        )}
                      />
                    </GridItem>
                    <GridItem style={{marginTop: '16px'}}>
                      <Controller
                        name={"affectation"}
                        rules={devisOptions.affectation}
                        control={control}
                        defaultValue="france"
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                          <FormControl variant="outlined" {...error && {error:true}} className={classes.selectFormControl}>
                          <InputLabel className={classes.selectLabel}>Origine Facturation</InputLabel>
                          <Select

                            style={{ width: "180px"}}
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            name="affectation"
                            onChange={(e) => {
                              setAffectation(e.target.value);
                              setAffectationManuallyChanged(Math.random());
                              onChange(e);
                            }}
                            value={value}
                            label="Origine Facturation"
                            >
                            <MenuItem value="france" classes={{ root: classes.selectMenuItem }}>France</MenuItem>
                            <MenuItem value="europe" classes={{ root: classes.selectMenuItem }}>Europe</MenuItem>
                            <MenuItem value="monde" classes={{ root: classes.selectMenuItem }}>Hors Europe</MenuItem>
                          </Select>
                          <FormHelperText>{error && error.message}</FormHelperText>
                          </FormControl>
                        )}
                      />
                    </GridItem>
                    <GridItem>
                      <Controller
                        name={"libelle"}
                        rules={devisOptions.libelle}
                        control={control}
                        defaultValue=""
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                          <Tooltip title={value}>
                          <TextField
                            id="libelle"
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            // style={{width:"250px"}}
                            disabled={readOnly}
                            label="Libelle"
                            classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                            InputLabelProps={{className: classes.textFieldLabel}}
                            type="text"
                            InputProps={{
                            classes: {input: clsx(classes.numberInput, classes.textFieldInput)}}}
                            value={value}
                            onChange={onChange}
                            {...error && {"error": true}}
                            {...error && {helperText: error.message}}
                        />
                        </Tooltip>
                        )}
                      />
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={8} md={4} lg={3} xl={2} style={{height:'100%'}}>
                  <GridContainer style={{height:'100%'}}>
                    <GridItem xs={12} sm={12} md={12} lg={12} xl={12} style={{height:'100%', marginTop: '16px', marginBottom: '8px'}}>
                      <Controller
                        name={"decorateur"}
                        // style={{display: "none"}}
                        rules={devisOptions.decorateur}
                        control={control}
                        
                        defaultValue={null}
                        // defaultValue={new Date().toISOString().slice(0, 10)}
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                          <Autocomplete
                            id="decorateur"
                            style={{ width: 250 }}
                            value={value}
                            onChange={(e, decorateur) => {
                              setValue("decorateur_id", decorateur?.client_id ? decorateur.client_id : null);
                              onChange(decorateur);
                            }}
                            disableListWrap
                            classes={{listbox: classes.listbox}}
                            ListboxComponent={ListBox}
                            options={contacts}
                            noOptionsText={
                              <Box display="flex" justifyContent="space-between" alignItems="center" >
                                Pas de résultats !
                                <Button
                                  variant="outlined"
                                  color={"success"}
                                  onMouseDown={() => {
                                    // manageDecorateurDialog(null)
                                    manageContactDialog(null, false, CONTACT_DECORATEUR_TYPE);
                                  }}
                                >
                                Ajoutez-en un
                                </Button>
                              </Box>
                            }
                            getOptionLabel={(option) => getLabelClient(option)}
                            getOptionSelected={(option, value) => {
                              return value.client_id === option.client_id
                            }}
                            renderInput={(params) => {
                              return <Tooltip title={params.inputProps.value} placement="bottom"><TextField {...params}                              
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: 
                                    <InputAdornment position="start">
                                      {value ? <Button round color={"primary"} onClick={()=> manageContactDialog(value.client_id, false, CONTACT_DECORATEUR_TYPE)} className={classes.actionButton + " " + classes.actionButtonRound}><Edit /></Button> : null}
                                      {!value ? <Button round color={"success"} onClick={()=> manageContactDialog(null, false, CONTACT_DECORATEUR_TYPE)} className={classes.actionButton + " " + classes.actionButtonRound}><Add /></Button> : null}
                                    </InputAdornment>
                                }}
                                variant="outlined"
                                label="Décorateur / Ensemblier"
                              /></Tooltip>}
                            }
                            renderOption={(option) => <Typography noWrap>{getLabelClient(option)}</Typography>}
                          />
                          )}
                      />
                      <input name="decorateur_id" type="number" {...register("decorateur_id")} hidden />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={12} xl={12} style={{height:'100%', marginTop: '8px'}}>
                      <Controller
                        name={"client"}
                        // style={{display: "none"}}
                        rules={devisOptions.client}
                        control={control}
                        // defaultValue={0}
                        defaultValue={null}
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                        <Autocomplete
                          id="client"
                          style={{ width: 250}}
                          value={value}
                          onChange={(e, client) => {
                            setValue("client_id", client?.client_id ? client.client_id : null);
                            onChange(client);
                          }}
                          disableListWrap
                          classes={{listbox: classes.listbox}}
                          ListboxComponent={ListBox}
                          getOptionLabel={(option) => getLabelClient(option)}
                          getOptionSelected={(option, value) => {
                            return value.client_id === option.client_id
                          }}
                          options={contacts}
                          noOptionsText={
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                              Pas de résultats !
                              <Button
                                variant="outlined"
                                color={"success"}
                                onMouseDown={() => {
                                  manageContactDialog(null, false, CONTACT_CLIENT_TYPE);
                                }}
                              >
                              Ajoutez-en un
                              </Button>
                            </Box>
                          }
                          renderInput={(params) => {
                            return <Tooltip title={params.inputProps.value} placement="bottom"><TextField {...params}                              
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: 
                                  <InputAdornment position="start">
                                    {value ? <Button round color={"primary"} onClick={()=> manageContactDialog(value.client_id, false, CONTACT_CLIENT_TYPE)} className={classes.actionButton + " " + classes.actionButtonRound}><Edit /></Button> : null}
                                    {!value ? <Button round color={"success"} onClick={()=> manageContactDialog(null, false, CONTACT_CLIENT_TYPE)} className={classes.actionButton + " " + classes.actionButtonRound}><Add /></Button> : null}
                                  </InputAdornment>
                              }}
                              variant="outlined"
                              label="Client"
                            /></Tooltip>}
                          }
                          renderOption={(option) => <Typography noWrap>{getLabelClient(option)}</Typography>}
                        />
                        )}
                      />
                      
                      <input name="client_id" type="number" {...register("client_id")} hidden />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={12} xl={12} style={{height:'100%'}}>
                      <Controller
                        name={"film"}
                        rules={devisOptions.film}
                        control={control}
                        defaultValue=""
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                          <Tooltip title={value}>
                          <TextField
                            id="film"
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            style={{width:"250px"}}
                            disabled={readOnly}
                            label="Film"
                            classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                            InputLabelProps={{className: classes.textFieldLabel}}
                            type="text"
                            InputProps={{
                            classes: {input: clsx(classes.numberInput, classes.textFieldInput)}}}
                            value={value}
                            onChange={onChange}
                            {...error && {"error": true}}
                            {...error && {helperText: error.message}}
                        />
                        </Tooltip>
                        )}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={12} xl={12} style={{height:'100%',marginTop: '8px', marginBottom: '8px'}}>
                      <Controller
                        name={"decor"}
                        rules={devisOptions.decor}
                        control={control}
                        defaultValue=""
                        render={({ 
                          field: { onChange, value },
                          fieldState: { invalid, isTouched, isDirty, error }
                        }) => (
                          <Tooltip title={value}>
                          <TextField
                            id="decor"
                            variant="outlined"
                            size="medium"
                            // margin="normal"
                            style={{width:"250px"}}
                            disabled={readOnly}
                            label="Décor"
                            classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                            InputLabelProps={{className: classes.textFieldLabel}}
                            type="text"
                            InputProps={{
                            classes: {input: clsx(classes.numberInput, classes.textFieldInput)}}}
                            value={value}
                            onChange={onChange}
                            {...error && {"error": true}}
                            {...error && {helperText: error.message}}
                        />
                        </Tooltip>
                        )}
                      />
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={9} xl={6} style={{height:'100%'}}>
                  <GridContainer style={{height:'100%'}} alignItems="flex-end" direction="column">
                    <GridItem xs={12} sm={12} md={12} lg={12} xl={12} style={{height:'100%'}}>
                  <Card style={{height:'100%', marginTop: '16px', maxWidth: '725px' }}>
                  <CardHeader style={{ width: '100%', height: '100%', backgroundColor: "#efefef", border: "1px solid #DDDDDD", borderBottom: 'none' }}>
                    <Typography variant="h6">Feuille de calcul</Typography>
                  </CardHeader>
                    <CardBody style={{ width: '100%', height: '100%', backgroundColor: "#efefef", border: "1px solid #DDDDDD" }}>
                      <GridContainer style={{height:'100%'}}>
                        <GridItem xs={12} style={{height:'100%', textAlign:'right'}}>
                          { 
                            total ?
                            <Prolongations onChange={setProlongations} prolongations={prolongations} total={total} dateDebut={dateDebutLocation} dateFin={dateFinLocation}/>
                            : null
                        }
                        </GridItem>
                        <GridItem xs={12} style={{height:'100%', textAlign:'right'}}>
                          <Controller
                                name={"sous_total_ht"}
                                rules={devisOptions.sous_total_ht}
                                control={control}
                                defaultValue={0}
                                render={({ 
                                  field: { onChange, value },
                                  fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                  <TextField
                                    id="sous_total_ht"
                                    variant="outlined"
                                    size="medium"
                                    style={{width:"135px", margin: "0 0 10px 10px", backgroundColor: "white"}}
                                    disabled={readOnly}
                                    label="Sous Total HT"
                                    classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                                    InputLabelProps={{className: classes.textFieldLabel}}
                                    type="number"
                                    InputProps={{
                                      readOnly: true,
                                      classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                                      startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                      inputProps: { 
                                        min: 0,
                                        step: 0.01
                                      }
                                    }}
                                    value={value}
                                    onChange={onChange}
                                    {...error && {"error": true}}
                                    {...error && {helperText: error.message}}
                                />
                                )}
                              />
                        </GridItem>
                        <GridItem xs={12} style={{height:'100%', textAlign:'right'}}>
                          <Controller
                                name={"remise_libelle"}
                                rules={devisOptions.remise_libelle}
                                control={control}
                                defaultValue=""
                                render={({ 
                                  field: { onChange, value },
                                  fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                  <Tooltip title={value}>
                                  <TextField
                                    id="remise_libelle"
                                    variant="outlined"
                                    size="medium"
                                    style={{width:"275px", margin: "0 0 10px 10px", backgroundColor: "white"}}
                                    disabled={readOnly}
                                    label="Libelle de remise"
                                    classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                                    InputLabelProps={{className: classes.textFieldLabel}}
                                    type="text"
                                    InputProps={{
                                    classes: {input: clsx(classes.numberInput, classes.textFieldInput)}}}
                                    value={value}
                                    onChange={onChange}
                                    {...error && {"error": true}}
                                    {...error && {helperText: error.message}}
                                />
                                </Tooltip>
                                )}
                              />
                          <Controller
                                name={"remise"}
                                rules={devisOptions.remise}
                                control={control}
                                defaultValue={0}
                                render={({ 
                                  field: { onChange, value },
                                  fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                  <TextField
                                    id="remise"
                                    variant="outlined"
                                    size="medium"
                                    style={{width:"135px", margin: "0 0 10px 10px", backgroundColor: "white"}}
                                    disabled={readOnly}
                                    label="Remise"
                                    classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                                    InputLabelProps={{className: classes.textFieldLabel}}
                                    type="number"
                                    InputProps={{
                                      classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                                      startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                      inputProps: { 
                                        min: 0,
                                        max: sousTotalHt,
                                        step: 1
                                      }
                                    }}
                                    value={value}
                                    onChange={(e) => {
                                      event.target.value === '' ? event.target.value = 0 : event.target.value
                                      event.target.value < 0 ? (event.target.value = 0) : event.target.value
                                      event.target.value = parseInt(e.target.value)
                                      setRemise(event.target.value);
                                      onChange(e);
                                    }}
                                    {...error && {"error": true}}
                                    {...error && {helperText: error.message}}
                                />
                                )}
                              />
                        </GridItem>
                        <GridItem xs={12} style={{height:'100%', textAlign:'right'}}>
                          <Controller
                            name={"display_valeur"}
                            rules={devisOptions.display_valeur}
                            control={control}
                            defaultValue={false}
                            render={({ 
                              field: { onChange, value },
                              fieldState: { invalid, isTouched, isDirty, error }
                            }) => (
                              <FormControl component="fieldset">
                                  <FormControlLabel 
                                  style={{ marginTop: "10px", color: "black"}}
                                    control={<Switch color="primary" 
                                      value={value}
                                      checked={value}
                                      onChange={(e) => {
                                        setDisplayValeur(e.target.checked);
                                        onChange(e)
                                      }} />}
                                    label="Afficher la valeur"
                                    labelPlacement="start"
                                  />
                              </FormControl>
                            )}
                          />
                          <Controller
                                name={"total_valeur"}
                                rules={devisOptions.total_valeur}
                                control={control}
                                defaultValue={0}
                                render={({ 
                                  field: { onChange, value },
                                  fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                  <TextField
                                    id="total_valeur"
                                    variant="outlined"
                                    size="medium"
                                    style={{width:"135px", margin: "0 0 10px 10px", backgroundColor: "white", display: !displayValeur ? "none": null}}
                                    disabled={readOnly}
                                    label="Total Valeur"
                                    classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                                    InputLabelProps={{className: classes.textFieldLabel}}
                                    type="number"
                                    InputProps={{
                                      readOnly: true,
                                      classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                                      startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                      inputProps: { 
                                        min: 0,
                                        step: 0.01
                                      }
                                    }}
                                    value={value}
                                    onChange={onChange}
                                    {...error && {"error": true}}
                                    {...error && {helperText: error.message}}
                                />
                                )}
                              />
                          <Controller
                                name={"total_ht"}
                                rules={devisOptions.total_ht}
                                control={control}
                                defaultValue={0}
                                render={({ 
                                  field: { onChange, value },
                                  fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                  <TextField
                                    id="total_ht"
                                    variant="outlined"
                                    size="medium"
                                    style={{width:"135px", margin: "0 0 10px 10px", backgroundColor: "white"}}
                                    disabled={readOnly}
                                    label="Total HT"
                                    classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                                    InputLabelProps={{className: classes.textFieldLabel}}
                                    type="number"
                                    InputProps={{
                                      readOnly: true,
                                      classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                                      startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                      inputProps: { 
                                        min: 0,
                                        step: 0.01
                                      }
                                    }}
                                    value={value}
                                    onChange={onChange}
                                    {...error && {"error": true}}
                                    {...error && {helperText: error.message}}
                                />
                                )}
                              />
                        </GridItem>
                        <GridItem xs={12} style={{height:'100%', textAlign:'right'}}>
                          <Controller
                                name={"tva"}
                                rules={devisOptions.tva}
                                control={control}
                                defaultValue={20}
                                render={({ 
                                  field: { onChange, value },
                                  fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                  <TextField
                                    id="tva"
                                    variant="outlined"
                                    size="medium"
                                    style={{width:"135px", margin: "0 0 10px 10px", backgroundColor: "white", display: getValues("affectation") !== "france" ? "none": null}}
                                    disabled={readOnly}
                                    label="TVA"
                                    classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                                    InputLabelProps={{className: classes.textFieldLabel}}
                                    type="number"
                                    InputProps={{
                                      classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                                      startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                      inputProps: { 
                                        min: 0,
                                        step: 0.1
                                      }
                                    }}
                                    value={value}
                                    onChange={(e) => {
                                      setTva(parseFloat(e.target.value));
                                      onChange(e);
                                    }}
                                    // onChange={onChange}
                                    {...error && {"error": true}}
                                    {...error && {helperText: error.message}}
                                />
                                )}
                              />
                          <Controller
                                name={"total_tva"}
                                rules={devisOptions.total_tva}
                                control={control}
                                defaultValue={20}
                                render={({ 
                                  field: { onChange, value },
                                  fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                  <TextField
                                    id="total_tva"
                                    variant="outlined"
                                    size="medium"
                                    style={{width:"135px", margin: "0 0 10px 10px", display: "none", backgroundColor: "white"}}
                                    disabled={readOnly}
                                    classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                                    InputLabelProps={{className: classes.textFieldLabel}}
                                    type="number"
                                    InputProps={{
                                      classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                                      inputProps: { 
                                        min: 0,
                                        step: 0.01
                                      }
                                    }}
                                    value={value}
                                    onChange={(e) => {
                                      onChange(e);
                                    }}
                                    {...error && {"error": true}}
                                    {...error && {helperText: error.message}}
                                />
                                )}
                              />
                          <Controller
                                name={"total_ttc"}
                                rules={devisOptions.total_ttc}
                                control={control}
                                defaultValue={0}
                                render={({ 
                                  field: { onChange, value },
                                  fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                  <TextField
                                    id="total_ttc"
                                    variant="outlined"
                                    size="medium"
                                    style={{width:"135px", margin: "0 0 10px 10px", backgroundColor: "white", display: getValues("affectation") !== "france" ? "none": null}}
                                    disabled={readOnly}
                                    label="Total TTC"
                                    classes={{root: clsx(classes.textFieldRoot, classes.numberInputRoot)}}
                                    InputLabelProps={{className: classes.textFieldLabel}}
                                    type="number"
                                    InputProps={{
                                      readOnly: true,
                                      classes: {input: clsx(classes.numberInput, classes.textFieldInput)},
                                      startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                      inputProps: { 
                                        min: 0,
                                        step: 0.01
                                      }
                                    }}
                                    value={value}
                                    onChange={onChange}
                                    {...error && {"error": true}}
                                    {...error && {helperText: error.message}}
                                />
                                )}
                              />



                            <input name="devis_id" type="number" {...register("devis_id")} hidden />
                            <input name="nb_elements" type="number" {...register("nb_elements")} hidden />
                            <input name="nb_lignes" type="number" {...register("nb_lignes")} hidden />
                        </GridItem>
                      </GridContainer>
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      
      {/* { params?.id ?  */}
      <GridContainer style={{height:'100%'}}>
        <GridItem xs={12} sm={12} style={{height:'100%'}}>
          <Card style={{height:'100%'}}>
            <CardHeader>
            <GridContainer>
              <GridItem xs={6} sm={6} md={12} lg={6}>
                <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
                  <MUIButton size="small" startIcon={<Add />} onClick={handleClick}>{addButtonOptions[selectedAdd]["label"]}</MUIButton>
                  <MUIButton
                    color="primary"
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="selectionnez un type d'ajout"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                  >
                    <ArrowDropDownIcon />
                  </MUIButton>
                </ButtonGroup>
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList id="split-button-menu">
                            {addButtonOptions.map((option, index) => (
                              <MenuItem
                                key={option['id']}
                                selected={index === selectedAdd}
                                onClick={(event) => handleMenuItemClick(event, index)}
                              >
                                {option['label']}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </GridItem>
            </GridContainer>
            </CardHeader>
            <CardBody style={{ width: '100%', height: '100%' }}>
            {displayPicture}
            <div style={{ width: '100%', height: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                <div style={{ overflow: 'hidden', flexGrow: '1' }}>
                  <div
                    id="myGrid"
                    style={{
                      height: '100%',
                      width: '100%',
                    }}
                    className="ag-theme-material"
                  >
                <AgGridReact
                  style={{ width: '100%', height: '100%' }} 
                  components={{
                    pictureDrawer: pictureDrawer,
                  }}
                  frameworkComponents={{
                    actionsDrawer: actionsDrawer,
                    numericCellEditor: NumericCellEditor,
                    booleanCellEditor: BooleanCellEditor,
                    availabilitiesCellEditor: AvailabilitiesCellEditor
                  }}
                  
                  rowHeight="70"
                  onCellClicked={onCellClicked}
                  // onRowClicked={onRowClicked}
                  // onRowSelected={onRowSelected}
                  localeText={localeText}
                  tooltipShowDelay="0"
                  reactUi={true}
                  className="ag-theme-material"
                  animateRows={true}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  enableRangeSelection="false"
                  rowData={rowData}
                  rowSelection="multiple"
                  suppressRowClickSelection={true}
                  // enableCellTextSelection="true"
                  onGridReady={onGridReady.bind(this)}
                  domLayout="autoHeight"
                  onRowDragEnd={onChangeOrders}
                  rowDragManaged={true}
                  rowDragEntireRow={true}
                  singleClickEdit={true}
                  onCellValueChanged={onCellValueChanged}
                  // onSortChanged={onSortChanged.bind(this)}
                  // pagination={true}
              />
            </div>
          </div>
          </div>
          </div>
        </CardBody>
        </Card>
     
      </GridItem>
      </GridContainer>

      {/* : null } */}
      </form>
      </div>
  );
}

Devis.propTypes = {
  devis: PropTypes.object,
  devis_id: PropTypes.number,
  onChange: PropTypes.func
};